import { Tile, TileContent, TileText } from '@one-thd/sui-atomic-components';
import { Settings } from '@one-thd/sui-icons';
import React from 'react';
export var PHTableSettingsTile = function (_a) {
    var setEnableSettingsDrawer = _a.setEnableSettingsDrawer;
    return (React.createElement("div", { className: "sui-flex sui-items-center sui-gap-[16px]" },
        React.createElement(Tile, { value: "table settings", "aria-label": "table settings", onClick: function () { return setEnableSettingsDrawer(true); }, tabIndex: 0, onKeyDown: function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    setEnableSettingsDrawer(true);
                }
            } },
            React.createElement(TileContent, null,
                React.createElement("span", { className: "sui-pt-1 " },
                    React.createElement(Settings, { color: "current", size: "small" })),
                React.createElement(TileText, null, "Table Settings")))));
};
